var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvaluation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M.81.8.8 21.2h14.4V.8zM14.002 20h-12l.011-18h11.99zm-10.8-8.4h2.4V9.2h-2.4zm3.598 0h2.4V9.2H6.801zm3.599 0h2.4V9.2H10.4l-.003 2.4Zm-7.2 3.599h2.4V12.8H3.201zm3.598 0h2.4V12.8H6.801zm3.599 0h2.4V12.8H10.4l-.006 2.398ZM3.2 18.8h2.4v-2.4H3.2zm3.598 0h2.4v-2.4H6.801L6.8 18.8Zm3.599 0h2.4v-2.4H10.4zm2.4-15.6H3.201V8h9.6zm-1.2 3.599H4.4V4.401h7.2z"
})));
export default SvgEvaluation;